var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLastMileDelivery = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 48 48"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  strokeLinecap: "round",
  transform: "translate(40.376 511.062)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M-3.3-471.5h4.6c.9 0 1.6-.7 1.6-1.6q0 0 0 0v-6.3c0-.9-.7-1.6-1.6-1.6h-5.7l-6.9-7.4h-8.4M-31.4-471.5h-4.3v-9.3l3.4-7.4h4.2M-12-471.5h-12"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -27.6,
  cy: -471.5,
  r: 3.3,
  stroke: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  cx: -8.1,
  cy: -471.5,
  r: 3.3,
  stroke: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#FFF",
  d: "M-27.7-480.8h23.9M-34.9-480.8h7.5"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#42A5F2",
  strokeMiterlimit: 10,
  transform: "translate(6.809)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: -30.8,
  cy: -497.7,
  r: 2.8
}), /*#__PURE__*/React.createElement("path", {
  d: "M-30.8-506c-4.4 0-7.9 3.5-7.9 7.9 0 5 5.7 12.1 7.4 14.1.2.3.7.3 1 .1 0 0 .1 0 .1-.1 1.8-2.1 7.4-9.1 7.4-14.1-.1-4.3-3.6-7.9-8-7.9z"
})))));
export default SvgLastMileDelivery;